import Vue from 'vue';

const state = () => ({
  loading: false,
  data: null
});

const getters = {};

const mutations = {
  loading(state, status) {
    state.loading = status;
  },

  succeed(state, data) {
    state.data = data;
  }
};

const actions = {
  async getMeetings({ commit }, { q, searchFields, pageNumber, pageSize, filters }) {
    commit('loading', true);
    const { data } = await Vue.prototype.$api.data.getMeetings({ q, searchFields, pageNumber, pageSize, filters });
    commit('succeed', data);
    commit('loading', false);
    return data;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
